import { useSearchParams } from 'react-router-dom';
import { useMonitoringGoods } from './MonitoringContext';

import GoodsDetailKeywordTable from './GoodsDetailKeywordTable';
import GoodsDetailAddKeyword from './GoodsDetailAddKeyword';
import GiveMeAlarm from './GiveMeAlarm';
import { useState } from 'react';
import TableChartToggle from './TableChartToggle';
import MakeExcelButton from './MakeExcelButton';
import GoodsDetailKeywordChart from './GoodsDetailKeywordChart';
import { MOCK_GOODS } from './_mock/mockGoods';
import useCheckMembership from '@/hooks/useCheckMembership';
const GoodsDetailKeyword = () => {
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');
  const [toggle, setToggle] = useState<'table' | 'chart'>('table');
  const { goods, isLoading, isError } = useMonitoringGoods();

  const selectedGoods =
    goods.find((item) => String(item.GoodsNo) === String(goodsNo)) ||
    MOCK_GOODS.find((item) => String(item.GoodsNo) === String(goodsNo));
  const keywordCount = selectedGoods?.RelatedKeyword?.length ?? 0;

  const isMockGoods = goodsNo === 'example';
  const isMember = useCheckMembership();

  const collectingNumber = isMockGoods ? 10 : isMember ? 10 : 2;

  return (
    <div className="mx-[60px] grid gap-y-[12px] rounded-[16px]  bg-white p-4">
      <div className="flex w-full justify-between">
        <div className="flex items-center gap-[12px]">
          <div className="flex items-center gap-1">
            <div className="text-gr-900 Body1S16">추적 키워드</div>
            <div className="flex gap-1 text-[14px] font-bold leading-[22px] text-gr-500">
              <span className="text-point-500">{keywordCount}</span>
              <span>/</span>
              <span>{collectingNumber}</span>
            </div>
          </div>
          <GoodsDetailAddKeyword isMockGoods={isMockGoods} />
        </div>
        <div className="flex gap-4 text-gr-900 Body1S16">
          <GiveMeAlarm isMockGoods={isMockGoods} />
          <TableChartToggle toggle={toggle} setToggle={setToggle} />
          <MakeExcelButton isMockGoods={isMockGoods} />
        </div>
      </div>
      <div className="scrollbar flex max-h-[410px] max-w-full flex-col overflow-x-auto">
        {selectedGoods && toggle === 'table' && (
          <GoodsDetailKeywordTable
            isMockGoods={isMockGoods}
            selectedGoods={selectedGoods}
            dailyList={selectedGoods.MonitoringGoodsDetailDailyList}
          />
        )}
        {selectedGoods && toggle === 'chart' && (
          <GoodsDetailKeywordChart dailyList={selectedGoods.MonitoringGoodsDetailDailyList} />
        )}
      </div>
    </div>
  );
};

export default GoodsDetailKeyword;
